<!--
 * @Author: guoyu
 * @Date: 2021-03-08 16:11:35
 * @LastEditors: your name
 * @LastEditTime: 2021-05-12 15:39:07
 * @Description: 常用的提交或者確認按鈕
-->
<template>
  <div class="button-inline-display">
    <div
      class="button-box"
      :class="{ 'button-disabled': disabled }"
      @click="$emit('click')"
    >
      <template v-if="!loading">
        <slot></slot>
      </template>
      <span v-else>
        <i class="el-icon-loading"></i>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped>
.button-inline-display {
  display: inline-block;
}
.button-box {
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  background: #fed838;
  border-radius: 99px;
  font-weight: 500;
  font-size: 14px;
  color: #222c43;
  cursor: pointer;
}
.button-disabled {
  background: #f1f4f6;
  color: #636d8630;
  cursor: not-allowed;
}
</style>
